import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentPreviewItemComponent } from './appointment-preview-item.component';

@NgModule({
	declarations: [AppointmentPreviewItemComponent],
	imports: [CommonModule, TranslateModule],
	exports: [AppointmentPreviewItemComponent],
	providers: [],
})
export class AppointmentPreviewItemModule {}
